import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { Section, Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { Image } from '@fiverr-private/media';

import { buttonShrinkClass } from './ContactSellersBanner.ve.css';

const TRANSLATIONS_KEY = 'skill_page_perseus.contact_sellers_banner';

export const ContactSellersBanner = () => (
    <Section
        backgroundColor="business_100"
        fullWidth
        paddingTop={{ default: '7', sm: '8', md: '14' }}
        paddingBottom={{ default: '9', sm: '8', md: '16' }}
    >
        <Stack
            direction={{ default: 'column', md: 'row' }}
            centered
            gap="0"
            justifyContent={{ default: 'flexStart', md: 'spaceBetween' }}
            alignItems="center"
            paddingTop="0"
            paddingBottom="0"
            padding="0"
            paddingLeft="8"
            paddingRight="6"
        >
            <Stack
                width={{ default: '100%', md: 'auto' }}
                direction="column"
                gap="2"
                alignSelf={{ default: 'flexStart', md: 'center' }}
                marginBottom={{ default: '10', md: '0' }}
            >
                <Typography as="h4" color="grey_1100">
                    <I18n k={`${TRANSLATIONS_KEY}.title`} />
                </Typography>
                <Typography as="p" color="grey_1200" marginBottom="4">
                    <I18n k={`${TRANSLATIONS_KEY}.subtitle`} />
                </Typography>
                <Button
                    className={buttonShrinkClass}
                    href={pathfinder('fbs_contact_us_page', {}, { query: { source: 'skill_pages' } })}
                    target="_blank"
                >
                    <I18n k={`${TRANSLATIONS_KEY}.cta`} />
                </Button>
            </Stack>
            <Image
                width={{ default: '100%', md: '50%' }}
                alt="contact sellers banner"
                src="https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/40ca650bf45e21093ae4b5be845d4d96-1712563262001/Desktop%20image.png"
            />
        </Stack>
    </Section>
);
